module.exports = __webpack_public_path__ + "static/media/open-to-anyone.9d728d60.png";